var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"j-inner-pay-btn",class:[
    _vm.classes,
    _vm.$platformClass,
    _vm.pointClass,
    _vm.isDtmslg ? 'is-dtmslg' : '',
    _vm.isUsArea ? 'is-us-area' : ''
  ],on:{"click":function($event){return _vm.passMethod('click')}}},[_c('div',{staticClass:"inner-tips",staticStyle:{"display":"none"}},[_vm._v("\n    "+_vm._s(_vm.languages.morePurchaseWay)+"\n  ")]),(_vm.isDlssr || _vm.isDl3dvn || _vm.isBeast)?_c('div',{staticClass:"inner-game-logo",class:[_vm.curLanguage]}):_vm._e(),_c('span',{class:[_vm.logoClass, _vm.$platformClass]}),_c('Button',{staticClass:"pay-btn",attrs:{"type":"selectInnerWay"}},[_vm._v("\n    "+_vm._s(_vm.isMuglo || _vm.isBeast || _vm.isDlssr || _vm.isDl3dvn
        ? _vm.languages.payBtn
        : _vm.languages.payBtnText)+"\n    "),(!_vm.$isOmni)?_c('Icon',{attrs:{"type":"selectInnerPay"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }